import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const conveyorCigarUnitsApi = {
  // GET
  getByCigarUnit: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorCigarUnits/byCigarUnit/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getStepRecordsByQr: async (qrId: string) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorCigarUnits/byQr`, {
        params: { qrId },
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default conveyorCigarUnitsApi;
